import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from '../../../universal/ui/components/App/App';
import configureStore from '../../../universal/ui/utils/configure-store';
import apiService from '../../../universal/ui/services/api';
import { getBreakpoint } from '../../../universal/ui/utils/breakpoints';
import { wrapElement } from '../../../universal/ui/utils/dom';

const correctBreakpointEstimate = estimate =>
  getBreakpoint(estimate) === getBreakpoint(window.innerWidth);

const reportBreakpointMismatch = (environment) => {
  if (environment === 'local') {
    console.error(`
      Estimated with did not match actual width.
      This suppresses markup errors.
      Make sure you develop with accurate emulation or you may miss errors.
    `);
  } else if (window.newrelic) {
    window.newrelic.noticeError(new Error('Estimated wrong breakpoint for responsive SSR.'));
  }
};

const container = document.getElementById('App');

if (container) {
  // eslint-disable-next-line no-underscore-dangle
  const initialState = JSON.parse(decodeURIComponent(window.__INITIAL_STATE__));

  const {
    location: { basename, baseURL },
    viewport: { width },
    config: { environment },
  } = initialState;

  const isCorrectBreakpoint = correctBreakpointEstimate(width);
  if (!isCorrectBreakpoint) reportBreakpointMismatch(environment);

  // Hack avoid the react markup warning without FAUC if not correct
  const target = isCorrectBreakpoint ? container : wrapElement(container);
  const store = configureStore(apiService({ baseURL: `${baseURL}api/` }), initialState);

  const app = (
    <BrowserRouter basename={basename}>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  );

  render(app, target);
}



// WEBPACK FOOTER //
// ./src/client/js/pages/index.js